import { render } from "./LeaveEntitlementReport.vue?vue&type=template&id=126efd7f&scoped=true"
import script from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=126efd7f&lang=scss&scoped=true"
import "./LeaveEntitlementReport.vue?vue&type=style&index=1&id=126efd7f&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126efd7f"]])

export default __exports__